/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../organization-settings/organization.settings.model.ts" />

module Eseebase {
    export class GeometryFace {
        levelId: string;
        vertices: Point3[];
        parameters: any;
        public maxZ() {
            var tmp = Number.MIN_VALUE;
            for (var i = 0; i < this.vertices.length; i++) {
                if (this.vertices[i].z > tmp) {
                    tmp = this.vertices[i].z;
                }
            }
            return tmp;
        }
        public minY() {
            var tmp = Number.MAX_VALUE;
            for (var i = 0; i < this.vertices.length; i++) {
                if (this.vertices[i].y < tmp) {
                    tmp = this.vertices[i].y;
                }
            }
            return tmp;
        }
    }

    export class TriangulatedFace {
        indices: number[];
        vertices: Point3[];
        housingNumber: string;
    }

    export class Point3 {
        constructor(public x: number, public y: number, public z: number) { }
    }

    export class Point2 {
        constructor(public x: number, public y: number) { }
    }

    export class BoundaryBox {
        min: Point3;
        max: Point3;
        constructor() {
            this.max = new Point3(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            this.min = new Point3(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);
        }
    }
}